<ion-card>
  <ion-card-content>
    <canvas
      #FoodCostGraph
      class="FoodCostGraph"
      [class.desktop]="platform === platformRef.desktop"
      [class.mobile]="platform === platformRef.mobile"
      [class.tablet]="platform === platformRef.tablet"
    ></canvas>
    <ng-container *ngIf="!!showGraph; else noData"> </ng-container>
  </ion-card-content>
</ion-card>

<ng-template #noData>
  <p
    class="center-title"
    [class.desktop]="platform === platformRef.desktop"
    [class.tablet]="platform === platformRef.tablet"
    [class.mobile]="platform === platformRef.mobile"
  >
    {{
      (reportsReady
        ? 'i18n.inventory.foodCost.tileReportsPlaceholderRange'
        : 'i18n.inventory.foodCost.tileReportsPlaceholder'
      ) | translate
    }}
  </p>
</ng-template>
